import Icon from "@chakra-ui/icon";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Divider,
} from "@chakra-ui/react";
import React from "react";
import Tweet from "./masonry/tweet";
import { ReplyComposer } from "../tweet-composer/replyComposer";
import { Masonry } from "masonic";
import LinkedinPost from "./masonry/linkedinPost";

function isEqual(prevProps, nextProps) {

  if (prevProps.data != nextProps.data
    // || true
  ) {
    // console.log("tweets not equal");
    return false;
  }
  return true;
}

const TweetAndReply = ({ tweet, removeTweet, addRemovedTweet, refresher, isFocused = false, ...rest }) => {

  const getPost = (tweet) => {
    if (tweet.data.type == "linkedin") {
      return (
        <LinkedinPost
          savedTweet={[]}
          tweet={tweet}
          removeTweet={removeTweet}
          refresher={refresher}
          disableBookmarkButton={false}
          disableMainHideButton={false}
          disableHideButton={false}
          mode="answer"
          disableRequest={true}
          disableUserPopup={false}
          {...rest}
        />
      )
    }
    else {
      return (
        <Tweet
          savedTweet={[]}
          tweet={tweet}
          removeTweet={removeTweet}
          refresher={refresher}
          disableBookmarkButton={false}
          disableMainHideButton={false}
          disableHideButton={false}
          mode="answer"
          disableRequest={true}
          disableUserPopup={false}
          {...rest}
        />
      )
    }
  }

  return (
    <Box key={tweet.data.id_str} maxW="800px">
      <Grid
        templateColumns={{ lg: "repeat(2, 1fr)", md: "repeat(1, 1fr)" }}
        columnGap={{ lg: 5, md: 0 }}
        rowGap={5}
      >
        <GridItem colSpan={1}>
          <Box w={400}>
            {getPost(tweet)}
          </Box>
        </GridItem>
        <GridItem colSpan={1}>
          <ReplyComposer tweet={tweet.data} removeTweet={removeTweet} addRemovedTweet={addRemovedTweet} isFocused={isFocused} />
        </GridItem>
      </Grid>
      <Divider mt={5} mb={5} />
    </Box>
  )
}




const TweetsReplies = ({ data, setData, refresher, linkedinPostProps = {} }) => {

  const [indexToFocus, setIndexToFocus] = React.useState(-1);
  const [idToFocus, setIdToFocus] = React.useState(-1);
  const [deletedTweetIndex, setDeletedTweetIndex] = React.useState(0);
  const removeTweet = (tw) => {
    if (data && setData != null) {
      //@ts-ignore
      let match = data.tweets.find(x => x.id_str === tw.id_str);
      let indexToRemove = data.tweets.indexOf(match);
      setDeletedTweetIndex(indexToRemove);
      // console.log("setDeletedTweetIndex to index " + indexToRemove);

      //@ts-ignore
      data.tweets.splice(indexToRemove, 1);
      //@ts-ignore
      setData({ ...data, tweets: [...data.tweets] });
      if (indexToRemove < data.tweets.length) {
        setIndexToFocus(indexToRemove);
        setIdToFocus(data.tweets[indexToRemove].id_str);
      }
      refresher({});
    }
  }

  const addRemovedTweet = (tw) => {
    // console.log("addRemovedTweet at index " + deletedTweetIndex, tw);
    if (deletedTweetIndex >= 0 && deletedTweetIndex < data.tweets.length) {
      data.tweets.splice(deletedTweetIndex, 0, tw);
      setData({ ...data, tweets: [...data.tweets] });
      refresher({});
    }
  }


  // console.log("render");
  // console.log(data.tweets);

  return (
    <Flex w="100%" maxW="800px" margin="auto" mt="10">
      {
        <Masonry
          key={data.tweets.length}
          items={data.tweets}
          columnCount={1}
          columnWidth={400}
          render={(tweet, index) => {
            return (
              <TweetAndReply
                tweet={tweet}
                removeTweet={removeTweet}
                addRemovedTweet={addRemovedTweet}
                refresher={refresher}
                isFocused={
                  //@ts-ignore
                  tweet?.data?.id_str == idToFocus}
                {...linkedinPostProps}
              />
            )
          }}
        />
      }
    </Flex>
  );
};

export default React.memo(TweetsReplies, isEqual);
